<template>
  <div class="NetworkSection">
    <div class="wrapper" :style="sectionStyle">
      <div class="cmpTitle">
        <div class="title" :style="titleStyle">{{title}}</div>
        <div class="image" v-if="image">
          <img :src="image" />
        </div>
      </div>
      <div class="description" v-html="text">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NetworkSection',
    data(){
      return {
      }
    },
    components:{
    },
    props: {
      id: {
        type: Number,
        default: ""
      },
      image: {
        type: String,
        default: ""
      },
      title: {
        type: String,
        default: ""
      },
      text: {
        type: String,
        default: ""
      },
      color: {
        type: String,
        default: "#000"
      }
    },
    computed: {
      sectionStyle(){
        return {
          borderTop: `4px solid ${this.color}`
        }
      },
      titleStyle(){
        return{
          color: this.color
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/common';

  .NetworkSection{
    font-size: 1rem;
    .wrapper{
      @media (max-width:  @bootstrap-lg - 1px){
        padding: 1.666em 1em 2.666em;
      }
      padding: 2.75em 1.5em;
      background: #fff;
      height: 100%;
      display: flex;
      align-items: stretch;
    }

    .cmpTitle{
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      img{
        margin-top: 4px;
        max-width: 100%;
      }
    }

    .description{
      font-size: 1.125em;
      font-weight: 300;
      line-height: 1.666em;
      @media (max-width:  @bootstrap-lg - 1px){
        font-size: 1em;
        line-height: 1.2em;
      }
    }

    .title{
      font-family: Futura,Trebuchet MS,Arial,sans-serif; 
      font-size: 3.75em;
      line-height: 1.333;
      font-weight: 700;
      margin-right: .25em;
      @media (max-width:  @bootstrap-lg - 1px){
        font-size: 2.5em;  
      }
    }
  }

</style>
